const requestIdleCallback =
  window.requestIdleCallback ||
  (fn => {
    fn()
  })
const cancelIdleCallback = window.cancelIdleCallback || (() => {})

export default function throttleIdle(fn, minInterval) {
  let nextCallArgs
  let handle
  let timeout
  let scheduled = false

  function result(...args) {
    nextCallArgs = args

    if (!scheduled) {
      scheduled = true
      timeout = setTimeout(() => {
        handle = requestIdleCallback(
          () => {
            scheduled = false
            fn(...nextCallArgs)
          },
          { timeout: 5000 },
        )
      }, window.REFRESH_INTERVAL || minInterval)
    }
  }

  result.cancel = () => {
    cancelIdleCallback(handle)
    clearTimeout(timeout)
    scheduled = false
  }

  return result
}
